"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanadianDangerousRequirementsLH4ToJSON = exports.CanadianDangerousRequirementsLH4FromJSONTyped = exports.CanadianDangerousRequirementsLH4FromJSON = exports.instanceOfCanadianDangerousRequirementsLH4 = void 0;
/**
 * Check if a given object implements the CanadianDangerousRequirementsLH4 interface.
 */
function instanceOfCanadianDangerousRequirementsLH4(value) {
    return true;
}
exports.instanceOfCanadianDangerousRequirementsLH4 = instanceOfCanadianDangerousRequirementsLH4;
function CanadianDangerousRequirementsLH4FromJSON(json) {
    return CanadianDangerousRequirementsLH4FromJSONTyped(json, false);
}
exports.CanadianDangerousRequirementsLH4FromJSON = CanadianDangerousRequirementsLH4FromJSON;
function CanadianDangerousRequirementsLH4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'emergency_response_plan_number_01': json['emergency_response_plan_number_01'] == null ? undefined : json['emergency_response_plan_number_01'],
        'communication_number_02': json['communication_number_02'] == null ? undefined : json['communication_number_02'],
        'packing_group_code_03': json['packing_group_code_03'] == null ? undefined : json['packing_group_code_03'],
        'subsidiary_classification_code_04': json['subsidiary_classification_code_04'] == null ? undefined : json['subsidiary_classification_code_04'],
        'subsidiary_classification_code_05': json['subsidiary_classification_code_05'] == null ? undefined : json['subsidiary_classification_code_05'],
        'subsidiary_classification_code_06': json['subsidiary_classification_code_06'] == null ? undefined : json['subsidiary_classification_code_06'],
        'subsidiary_risk_indicator_code_07': json['subsidiary_risk_indicator_code_07'] == null ? undefined : json['subsidiary_risk_indicator_code_07'],
        'net_explosive_quantity_08': json['net_explosive_quantity_08'] == null ? undefined : json['net_explosive_quantity_08'],
        'canadian_hazardous_notation_09': json['canadian_hazardous_notation_09'] == null ? undefined : json['canadian_hazardous_notation_09'],
        'special_commodity_indicator_code_10': json['special_commodity_indicator_code_10'] == null ? undefined : json['special_commodity_indicator_code_10'],
        'communication_number_11': json['communication_number_11'] == null ? undefined : json['communication_number_11'],
        'unit_or_basis_for_measurement_code_12': json['unit_or_basis_for_measurement_code_12'] == null ? undefined : json['unit_or_basis_for_measurement_code_12'],
        'hazardous_material_shipment_information_qualifier_13': json['hazardous_material_shipment_information_qualifier_13'] == null ? undefined : json['hazardous_material_shipment_information_qualifier_13'],
        'quantity_14': json['quantity_14'] == null ? undefined : json['quantity_14'],
        'unit_or_basis_for_measurement_code_15': json['unit_or_basis_for_measurement_code_15'] == null ? undefined : json['unit_or_basis_for_measurement_code_15'],
    };
}
exports.CanadianDangerousRequirementsLH4FromJSONTyped = CanadianDangerousRequirementsLH4FromJSONTyped;
function CanadianDangerousRequirementsLH4ToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'emergency_response_plan_number_01': value['emergency_response_plan_number_01'],
        'communication_number_02': value['communication_number_02'],
        'packing_group_code_03': value['packing_group_code_03'],
        'subsidiary_classification_code_04': value['subsidiary_classification_code_04'],
        'subsidiary_classification_code_05': value['subsidiary_classification_code_05'],
        'subsidiary_classification_code_06': value['subsidiary_classification_code_06'],
        'subsidiary_risk_indicator_code_07': value['subsidiary_risk_indicator_code_07'],
        'net_explosive_quantity_08': value['net_explosive_quantity_08'],
        'canadian_hazardous_notation_09': value['canadian_hazardous_notation_09'],
        'special_commodity_indicator_code_10': value['special_commodity_indicator_code_10'],
        'communication_number_11': value['communication_number_11'],
        'unit_or_basis_for_measurement_code_12': value['unit_or_basis_for_measurement_code_12'],
        'hazardous_material_shipment_information_qualifier_13': value['hazardous_material_shipment_information_qualifier_13'],
        'quantity_14': value['quantity_14'],
        'unit_or_basis_for_measurement_code_15': value['unit_or_basis_for_measurement_code_15'],
    };
}
exports.CanadianDangerousRequirementsLH4ToJSON = CanadianDangerousRequirementsLH4ToJSON;
